
















import { Component, Prop, Vue } from "vue-property-decorator";
import { TweenMax, Power2 } from "gsap";

@Component
export default class Title extends Vue {
  @Prop() private msn: any;
  title = { x: "LIGHT" };

  mounted() {
    TweenMax.to(this.title, 1, {
      x: this.title.x,
      repeat: -1,
      onRepeat: () => {
        if (this.title.x == "LIGHT") {
          this.title.x = "SKILLS";
        } else if (this.title.x == "SKILLS") {
          this.title.x = "DOJO";
        } else {
          this.title.x = "LIGHT";
        }
      }
    });
  }
}
